/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
function n(e) {
  return e.hoverOpenDelay !== void 0 ? e.hoverOpenDelay : e.openOnClick ? 0 : 100;
}
function l(e) {
  return e.hoverCloseDelay !== void 0 ? e.hoverCloseDelay : 100;
}
export {
  l as getHoverCloseDelay,
  n as getHoverOpenDelay
};
